import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signoff',
  templateUrl: './signoff.page.html',
  styleUrls: ['./signoff.page.scss'],
})
export class SignoffPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
